export class Cl_Pacible
{
    No_Ligne : number = 0; // int
    No_Scenario : number = 0; // int
    Cd_Reduction_Onss : string = ""; // string
    Total_Trimestre : number = 0; // int
    Montant : number = 0; // double
}

export class Cl_Ty_Prest
{
    Cd_Prest : string ="";
    Libelle : string ="";
    Libelle_Court : string ="";
}

export interface resultReadableJc {
    keyX: string,
    keyFr: string,
    keyNl: string
}

export default class ResultData {
    resultOK : boolean = false; // bool
    simulationStatus : number = 0; // int
    message : string = ""; // string
    BRUT : number = 0; // double
    R6R : number = 0; // int
    R6S : number = 0; // int
    T80 : number = 0; // double
    T10 : number = 0; // double
    R10 : number = 0; // double
    R11 : number = 0; // double
    R14 : number = 0; // double
    R1W : number = 0; // double, replaced by R1R and R1S
    R1R : number = 0; // double
    R1S : number = 0; // double
    R1L : number = 0; // double
    R1Y : number = 0; // double
    R1Z : number = 0; // double
    R82 : number = 0; // double
    T20 : number = 0; // double
    T30 : number = 0; // double
    R30 : number = 0; // double
    R31 : number = 0; // double
    R32 : number = 0; // double
    R3B : number = 0; // double
    R3C : number = 0; // double
    R3D : number = 0; // double
    R3E : number = 0; // double
    R3F : number = 0; // double
    TOTR32 : number = 0; // double
    R34 : number = 0; // double
    T40A : number = 0; // double
    T40 : number = 0; // double
    T50 : number = 0; // double
    T60 : number = 0; // double
    T70 : number = 0; // double
    PA1 : number = 0; // double
    PA2 : number = 0; // double
    PA4 : number = 0; // double
    PA5 : number = 0; // double
    TOTRP : number = 0; // double
    TOTCP : number = 0; // double
    TOT12 : number = 0; // double
    TOTSS : number = 0; // double
    R1U : number = 0; // double

    // 
    Commissions : number = 0; // double
    Avantage_Nature : number = 0; // double
    Avantage_Nature_Voiture : number = 0; // double
    Precompte_Autre : number = 0; // double
    Abonnement_Social : number = 0; // double
    Frais_Deplacement : number = 0; // double
    Divers_Net_Pos : number = 0; // double
    Assurance_Groupe : number = 0; // double
    Divers_Net_Neg : number = 0; // double
    PA3 : number = 0; // double
    Nb_Heure_Mois : string = ""; // string
    Nb_Jour_Mois : number = 0; // int
    Cheque_Repas_Travailleur : number = 0; // double

    // Partie Signaletique
    Nom : string = ""; // string
    Etat_Civil : string = ""; // string
    Handicape : boolean = false; // bool
    Conjoint : string = ""; // string
    Nb_Enfant_Charge : number = 0; // int
    Nb_Enfant_Charge_Hand : number = 0; // int
    Nb_Autre_Charge : number = 0; // int
    Nb_Autre_Charge_Hand : number = 0; // int
    Nbr_Autre_Plus65 : number = 0; // int
    Nbr_Autre_Plus65_Hand : number = 0; // int
    Typ_Contrat : string = ""; // string
    Templ_Plein_Partiel : string = ""; // string
    Soumis_Onss : string = ""; // string
    Soumis_Precompte : string = ""; // string
    Horaire : string = ""; // string
    Com_Par : string = ""; // string
    Pref_Onss : string = ""; // string
    Effectif_Employeur : string = ""; // string
    cd_region_domicile : number = 0; // int 
    R4C : number = 0; // double
    R04 : number = 0; // double
    X89D : number = 0; // double


    // Lc le 3/10/2013
    Cotisation_Onss_Pers : number = 0; // double
    
    // Lc le 15/10/2015
    R19 : number = 0; // double

    // Lc le 20/06/2016
    Premier_Code_Pa5 : string = ""; // string
    Premier_Code_Pa5_Montant : number = 0; // double
    Premier_Code_Pa5_Libelle : string = ""; // string

    Second_Code_Pa5 : string = ""; // string
    Second_Code_Pa5_Montant : number = 0; // double
    Second_Code_Pa5_Libelle : string = ""; // string

    Scenario_1er_Engage : Array<Cl_Pacible> = new Array<Cl_Pacible>(); // list<Cl_Pacible>

    // Lc le 20/03/2017
    R4I : number = 0; // double
    R4J : number = 0; // double
    R1M : number = 0; // double
    JB4 : number = 0; // double
    Somme_R4I_R4J : number = 0; // double

    //#112627 - Sociale Maribel
    P1C : number = 0; // double

    ReadableJc: resultReadableJc = {keyX: "", keyFr: "", keyNl: ""};
}